// extracted by mini-css-extract-plugin
export default {"dropdown-container":"customization-bar_dropdown-container__l11pF"};